import React from 'react';
import { useState } from 'react';
import Header from '../JobPage/Header';
import Footer from '../JobPage/Footer';
import { useNavigate } from 'react-router-dom';
import { Container } from '../Components/ui/container';
import { Stack, Grid } from '../Components/ui/layout';
import { Heading } from '../Components/ui/typography';
import { Card } from '../Components/ui/card';
import { Button } from '../Components/ui/button';

const trendCardsData = [
  {
    leftImage: "https://cdn.builder.io/api/v1/image/assets/TEMP/48fbcbadc050b9a9a41ebcc30e6ddbd5227393bda9188edee7ea101cdaf511bb?placeholderIfAbsent=true&apiKey=011132b2f41c4af7b38e22acc88aa803",
    rightImage: "https://cdn.builder.io/api/v1/image/assets/TEMP/0fd02aac4d785d268b0cfd60ec401aa12b5f46d8bdde5316f1974a5329703a10?placeholderIfAbsent=true&apiKey=011132b2f41c4af7b38e22acc88aa803",
    leftTitle: "Open Tech Jobs",
    rightTitle: "Big Tech Hiring"
  },
  {
    leftImage: "https://cdn.builder.io/api/v1/image/assets/TEMP/4508f0006066ac5c46e984a41f4322b47e1d9202e80811665c6c8d45906ca64a?placeholderIfAbsent=true&apiKey=011132b2f41c4af7b38e22acc88aa803",
    rightImage: "https://cdn.builder.io/api/v1/image/assets/TEMP/70d1fe86cfd1430860372f6566d995135033e0c6136ca44db68951538a7d9973?placeholderIfAbsent=true&apiKey=011132b2f41c4af7b38e22acc88aa803",
    leftTitle: "Top Tech Company",
    rightTitle: "Hottest Companies by Sector"
  },
  {
    leftImage: "https://cdn.builder.io/api/v1/image/assets/TEMP/168dcf7e9e31b38dd70e8cc360b849871d9725d7cab45305e11cffe118613bc4?placeholderIfAbsent=true&apiKey=011132b2f41c4af7b38e22acc88aa803",
    rightImage: "https://cdn.builder.io/api/v1/image/assets/TEMP/7ae6a10b7fad66b4a1e31e73d1be3a9b31dc40098762ea5f95ef02586f579ebd?placeholderIfAbsent=true&apiKey=011132b2f41c4af7b38e22acc88aa803",
    leftTitle: "Hottest Companies by Investor",
    rightTitle: "Top Tech Location"
  },
  {
    leftImage: "https://cdn.builder.io/api/v1/image/assets/TEMP/bc23ed77a80a7219c25d2f8dd5c2d49aa429095bff08964033aefa53005373ca?placeholderIfAbsent=true&apiKey=011132b2f41c4af7b38e22acc88aa803",
    rightImage: "https://cdn.builder.io/api/v1/image/assets/TEMP/d7e49242024b8605ad750d45a8c826f4abd67af95d6518654bd491f5e71daff9?placeholderIfAbsent=true&apiKey=011132b2f41c4af7b38e22acc88aa803",
    leftTitle: "Tech Industry Stats",
    rightTitle: "Remote Index"
  },

  // Add more trend data
];

export function TrendsLayout() {
    const [showAll, setShowAll] = useState(false);
    const visibleCards = showAll ? trendCardsData : trendCardsData.slice(0, 3);
  
    const toggleCards = ()=>{
        setShowAll(!showAll);
    }

    const navigate = useNavigate();


    const trendRoutes={
      "Open Tech Jobs": "/OpenTechJobs",
      "Big Tech Hiring": "/BigTechHiring",
      "Top Tech Company": "/TopTechCompany",
      "Hottest Companies by Sector": "/HottestCompaniesBySector",
      "Top Tech Location": "/TopTechLocation",
      "Hottest Companies by Investor": "/HottestCompaniesByInvestor",
      "Tech Industry Stats": "/TechIndustryStats",
      "Remote Index": "/RemoteIndex"
    }

    const onCatClick = (title) => {
      const route = trendRoutes[title];
      if (route) {
        navigate(route, {
          state: { 
            activeTab: title,
            selectedTrend: title
          }
        });
      }
    };

    return (
    <main className="min-h-screen bg-background">
      <Header />
      <Container>
        <Stack spacing="2xl" className="py-xl">
          <Heading level="h1" className="text-center text-4xl md:text-5xl bg-gradient-to-r from-primary to-primary/60 bg-clip-text text-transparent">
            Trends & Charts
          </Heading>
          
          <Grid cols={1} gap="xl">
            {visibleCards.map((data, index) => (
              <Card key={index} className="p-6 hover:shadow-lg transition-shadow">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div 
                    className="relative group cursor-pointer overflow-hidden rounded-lg"
                    onClick={()=>onCatClick(data.leftTitle)}
                  >
                    <img 
                      className="w-full h-64 object-cover rounded-lg transition-transform group-hover:scale-105" 
                      src={data.leftImage} 
                      alt={data.leftTitle} 
                      loading="lazy" 
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity rounded-lg" />
                    <h2 className="absolute bottom-4 left-4 right-4 text-white font-semibold text-lg opacity-0 group-hover:opacity-100 transition-opacity">
                      {data.leftTitle}
                    </h2>
                  </div>
                  <div 
                    className="relative group cursor-pointer overflow-hidden rounded-lg"
                    onClick={()=>onCatClick(data.rightTitle)}
                  >
                    <img 
                      className="w-full h-64 object-cover rounded-lg transition-transform group-hover:scale-105" 
                      src={data.rightImage} 
                      alt={data.rightTitle} 
                      loading="lazy" 
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity rounded-lg" />
                    <h2 className="absolute bottom-4 left-4 right-4 text-white font-semibold text-lg opacity-0 group-hover:opacity-100 transition-opacity">
                      {data.rightTitle}
                    </h2>
                  </div>
                </div>
              </Card>
            ))}
          </Grid>

          <div className="flex justify-center">
            <Button variant="outline" size="lg" onClick={toggleCards}>
              {showAll ? 'Show Less' : 'More'}
            </Button>
          </div>
        </Stack>
      </Container>
      <Footer />
    </main>
  );
}

export default TrendsLayout;